import { metersToOtherUnitsOfMeasure, metersToOtherUnitsOfMeasureRounded } from "./meters-to-other-units-of-measure";
import { otherUnitsOfMeasureToMeters, otherUnitsOfMeasureToMetersRounded } from "./other-units-of-measure-to-meters";

export const FlightZoneUtils = {
    metersToOtherUnitsOfMeasure,
    metersToOtherUnitsOfMeasureRounded,
    otherUnitsOfMeasureToMeters,
    otherUnitsOfMeasureToMetersRounded,
};
